module.exports = __webpack_public_path__ + "static/media/logo2.74ad2932.png";